import { render, staticRenderFns } from "./Invigilation.vue?vue&type=template&id=3c34fd5f"
import script from "./Invigilation.vue?vue&type=script&lang=js"
export * from "./Invigilation.vue?vue&type=script&lang=js"
import style0 from "./Invigilation.vue?vue&type=style&index=0&id=3c34fd5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports